import React from 'react'
import DateTimeRangeFilter, {
  DateFilterObject,
} from '../../../../../common/filter/DateTimeRangeFilter'

interface Props {
  value?: { from?: Date; to?: Date }
  onChange: (v: { from?: Date; to?: Date }) => void
  hideRanges?: boolean
  className?: string
}

// Тонкая адаптация под FilterManager (as in Audit/Disputes/Overpayments — dateRange
// пока не реализован внутри FilterManager, поэтому подключается через customFilters).
// DateTimeRangeFilter — единственная реализация «Текущая/Предыдущая смена» с
// правильными границами (00:00 vs 08:00/20:00 при currentShift); свой расчёт смен
// заводить нельзя — расходится с остальными разделами (CPAYMENT-1739 QA).
export const LedgerDateRangeFilter: React.FC<Props> = ({
  value,
  onChange,
  hideRanges,
  className,
}) => (
  <DateTimeRangeFilter
    filter={{ dateStart: value?.from ?? null, dateEnd: value?.to ?? null }}
    updateTime={(d: DateFilterObject) =>
      onChange({ from: d.dateStart ?? undefined, to: d.dateEnd ?? undefined })
    }
    hideRanges={hideRanges}
    className={className}
  />
)

export default LedgerDateRangeFilter
